// @file Surface share panel store
import { WallAccessPrivacyType, WallAccessRight } from '@@/enums'
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useSurfaceSharePanelStore = defineStore('surfaceSharePanelStore', () => {
  // State
  const xSurfaceSharePanel = ref(false)
  const privacyType = ref(WallAccessPrivacyType.Public) // dummy value
  const visitorRight = ref(WallAccessRight.None) // dummy value
  // Getters
  // Actions

  return {
    // State
    xSurfaceSharePanel,
    privacyType,
    visitorRight,
    // Getters
    // Actions
  }
})
